module.exports = __webpack_public_path__ + "assets/img/about-pic1.26671485.png";